/**
 * Модуль инициализации flatPicker (календари).
 * Находим элемент по селектору и инициализируем его
 */
itsoftApp.createModule('flatPickerInit', ['flatPickerLibrary'], function () {
    // Локальные переменные
    let module = this;

    const sliderConfig = {
        name: 'babyBornCounter',
        events: {
            update: function (value) {
                const childrenCountInput = document.getElementById('children-count');
                const [val] = value;

                if (childrenCountInput) childrenCountInput.value = val;
            }
        }
    };

    const flatPickerInit = function () {
        const slider = document.querySelector('.js-flatpicker-date');
        //
        if (slider) {
            itsoftApp.modules.flatPickerLibrary.callback(slider);
        }
    };

    flatPickerInit();
    module.callback = flatPickerInit;
});
